import request from "../../utils/api";

const url = "api/v1/users"

export const getUsers = params => request(url, { params })
export const getSingleUser = id => request(`${url}/${id}`)

export const getClients = params => {
  params = { ...params, type: 2 }
  return request(url, { params })
}

export const inviteUser = body => request(url, { method: "post", body })
export const registerUser = body => request(`${url}/register`, { method: "post", body })
export const updateUser = (id, body) => request(`${url}/${id}`, { method: "put", body })
export const updateUserStatus = (id, body) => request(`${url}/${id}/status`, { method: "put", body })
export const deleteUser = id => request(`${url}/${id}`, { method: "delete" })
export const reInviteUser = body => request(`${url}/resend`, { method: "post", body })
export const deleteProfile = (body, id) => request(`${url}/deleteAuth/${id}`, { method: "post", body })



// WEBPACK FOOTER //
// ./src/modules/user/service.js